module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/ian_shrug_laugh-f19e9de88cd7960d4eff1c212c0e2d5f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/ian_shrug_laugh.png
// module id = 2379
// module chunks = 2